<form (ngSubmit)="save()" #formCheckiIn="ngForm">
    
    <div class="card card-custom gutter-b card-strech me-0">
        <div class="card-header py-2 justify-content-between">
            <div class="card-title">
                <h3 class="card-label">Check-in</h3>
            </div>

            <button type="submit" class="btn btn-primary btn-sm" [disabled]="formCheckiIn.invalid">
                Save Changes
            </button>
        </div>
        <div class="card-body mt-0 pt-4">
            <div class="row">
                <div class="col-lg-4 col-md-6  mb-3 form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <button class="btn btn-secondary btn-sm w-min-button" (click)="openStatModal(36)">Body Condition Score</button>
                        </div>
                        <select class="form-control form-select-sm" id="inputGroupSelect02"
                                    name="_profile_bcs" [(ngModel)]="petService.pet_profile[4].profile">
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-8 col-md-6 mb-3 form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <button class="btn btn-secondary btn-sm" type="button" (click)="open()">Referred by</button>
                        </div>
                        <input type="text" class="form-control form-control-sm" name="_refer"
                      [(ngModel)]="petService.pet_refer.refer" />
                    </div>
                </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
               <div class="row">
                <div class="col-lg-12 col-md-6 col-sm-6 mb-3 form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <button class="btn btn-secondary btn-sm w-min-button" (click)="openStatModal(1)">Weight <small>(lbs)</small></button>
                        </div>
                        <input type="text" class="form-control form-control-sm" name="_profile_weight"
                                    [(ngModel)]="petService.pet_profile[0].profile" />
                    </div>
                </div>
                <div class="col-lg-12 col-md-6 col-sm-6 mb-3 form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <button class="btn btn-secondary btn-sm w-min-button" (click)="openStatModal(2)">Temperature</button>
                        </div>
                        <input type="text" class="form-control form-control-sm" name="_profile_temperature"
                                    [(ngModel)]="petService.pet_profile[1].profile" />
                    </div>
                </div>
                <div class="col-lg-12 col-md-6 col-sm-6 mb-3 form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <button class="btn btn-secondary btn-sm w-min-button" (click)="openStatModal(3)">Respiration <small>(cycles)</small></button>
                        </div>
                        <input type="text" class="form-control form-control-sm" name="_profile_respiration"
                                    [(ngModel)]="petService.pet_profile[2].profile" />
                    </div>
                </div>
                <div class="col-lg-12 col-md-6 col-sm-6 mb-3 form-group">

                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <button class="btn btn-secondary btn-sm w-min-button" (click)="openStatModal(4)">BP <small>(Sys/Dia) (mm HG)</small></button>
                        </div>
                        <input type="text" class="form-control form-control-sm" name="_profile_bp"
                                    [(ngModel)]="petService.pet_profile[3].profile" />
                    </div>
                </div>
                <div class="col-lg-12 col-md-6 col-sm-6 mb-3 form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text w-min-button">Invoice Limit $</span>
                        </div>
                        <input type="text" class="form-control form-control-sm" name="_invoice_limit"
                                        [(ngModel)]="petService.pet_visit.invoice_limit" />
                    </div>
                    
                </div>
                <div class="col-lg-12 col-md-6 col-sm-6 mb-3 form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="btn btn-secondary btn-sm w-min-button" (click)="openDoctorNurseModal()">Attending Doctor</span>
                        </div>
                    <select class="form-control form-select-sm" name="_assigned_doctor" [(ngModel)]="petService.pet_visit.assigned_doctor">
                        <option *ngFor="let item of managerialService.doctorDDList" [value]="item.employee_no">{{item.employee_name}}</option>
                    </select>
                    </div>
                </div>
               <div class="col-lg-12 mb-3 form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                                <span class="input-group-text w-min-button">Discharge Time</span>
                            </div>
                            <input type="time" class="form-control form-control-sm" name="_discharge_time"
                                            [(ngModel)]="petService.pet_visit.discharge_time" />
                    
                        </div>
                 </div>
               </div>
              </div>
              <div class="col-lg-8">
                <div class="row">
                    <div class="col-lg-12 mb-3 form-group">
                        <label class="form-label form-label-sm"  for="_note_text_chief">Chief complaint(s):</label>
                        <textarea class="form-control form-control-sm" name="_note_text_chief" rows="3" id="_note_text_chief"
                                        [(ngModel)]="petService.pet_notes_checkin[0].note_text"></textarea>
                    </div>
                    <div class="col-lg-12 mb-3 form-group">
                        <label class="form-label form-label-sm" for="_note_text_history">History:</label>
                        <textarea class="form-control form-control-sm" name="_note_text_history" rows="3" id="_note_text_history"
                                        [(ngModel)]="petService.pet_notes_checkin[1].note_text"></textarea>
                    </div>
             
                    <div class="col-lg-12 mb-lg-0 mb-4 form-group">
                        <label class="form-label form-label-sm" for="_note_text_medical">Medical Note(s):</label>
                        <textarea class="form-control form-control-sm" name="_note_text_medical" rows="3" id="_note_text_medical"
                        [(ngModel)]="petService.pet_notes_checkin[2].note_text"></textarea>
                    </div>
                </div>
              </div>
            </div>
         
        </div>
      
    </div>
</form>


<!-- Modal -->
<div class="modal fade" id="modalCheckRefer" tabindex="-1" role="dialog" aria-labelledby="modalCheckRefer"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalNewPetNoteLabel">Referred By</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <form (ngSubmit)="refer()" #formCheckiInRefer="ngForm" >
            <div class="modal-body">
                    <div class="row">
                                    <div class="col-lg-12 mb-4 form-group">
                                            <label>
                                                Refer Doctor: 
                                            </label>
                                            <input type="text" class="form-control form-control-sm" required ngxRequiredField name="_refer_doctor" [(ngModel)]="petService.pet_refer.refer_doctor">
                                    </div>
                                    <div class="col-lg-12 mb-4 form-group">
                                            <label>
                                                Refer Hospital:
                                            </label>
                                            <input type="text" class="form-control form-control-sm" required name="_refer_hospital" [(ngModel)]="petService.pet_refer.refer_hospital">
                                    </div>
                    </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary btn-sm" [disabled]="formCheckiInRefer.invalid">
                    Save
                </button>
            </div>
            </form>
        </div>
    </div>
</div>

<style>
    .col_turquoise {
        color: #00c5c5;
        text-decoration: underline;
        cursor: pointer;
    }
    .required {
        color: red;
    }

    .w-min-button {
        min-width: 149.5px!important;
        text-align: left!important;
    }

    .form-label-sm {
  font-size: 0.875rem;
  font-weight: 400;
}
</style>